import { Skeleton } from '@mui/material';
import FullPageDrawer from 'components/new/FullPageDrawer';
import { Column } from 'further-ui/components/Layout';

const PageLoader: React.FC = () => (
  <FullPageDrawer
    open={true}
    size="lg"
    title={
      <Column spacing="sm" fullWidth>
        <Skeleton variant="rectangular" height={32} />
        <Skeleton variant="rectangular" height={54} />
      </Column>
    }
    actions={<></>}
  >
    <Column spacing="sm">
      <Skeleton variant="rectangular" height={30} />
      <Skeleton variant="rectangular" height={300} />
      <Skeleton variant="rectangular" height={400} />
    </Column>
  </FullPageDrawer>
);

export default PageLoader;
